import { FormEvent, useState } from "react";

import Input from "../Input";
import { toastError } from "../Toast";
import useAuthData from "../../hook/useAppData";
import "./AddNewFieldSelect.scss";

export interface IInfo {
  label: string;
  value: number;
  name: string;
  action: () => void;
  exit: () => void;
  save: (body, token: string) => Promise<any>;
  objSave: (value) => Object;
}

export function AddNewFieldSelect({ info }: { info: IInfo }) {
  const { token } = useAuthData();
  const [value, setValue] = useState("");

  function handleSubmit(event: FormEvent) {
    event.preventDefault();
    save();
  }

  async function save() {
    const res = await info.save(info.objSave(value), token);
    if (!res?.ok) return toastError(`Não foi possivel cadastar a ${info.label}`);
    hasAllOk();
  }

  function hasAllOk() {
    info.action();
    info.exit();
  }

  return (
    <>
      <form onSubmit={handleSubmit} className="add-new-field-select center flex">
        <Input
          name={info?.name}
          label={info?.label}
          placeholder={`Adicionar ${info?.label}`}
          value={value}
          setValue={(e) => setValue(e.target.value)}
          autofocus={true}
        />
        <button type="submit" className="btn bg-primary center">
          Adicionar
        </button>
      </form>
    </>
  );
}
